<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button @click="cerrarModal({recargar: true});">
          <ion-icon slot="icon-only"  name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title v-text="'FILTROS'"></ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <div class="container-fluid my-4">
      <div  class="row">
        <div class="col-4">
          <h6>Filtrar por sucursal</h6>
          <ion-toggle @ionChange="filtros.filtroSucursal = !filtros.filtroSucursal" :checked="filtros.filtroSucursal" style="padding:5px;" ></ion-toggle>
        </div>
        <div class="col-4">
          <h6>Filtrar por fecha</h6>
          <ion-toggle @ionChange="filtros.filtroFecha = !filtros.filtroFecha; listarAnosEventos();" :checked="filtros.filtroFecha" style="padding:5px;" ></ion-toggle>
        </div>
        <div class="col-4">
          <h6>Filtrar por tipo</h6>
          <ion-toggle :disabled="filtros.empresa == ''" @ionChange="filtros.filtroTipo = !filtros.filtroTipo; listarTipos();" :checked="filtros.filtroTipo" style="padding:5px;" ></ion-toggle>
        </div>
      </div>

      <div v-if="filtros.filtroSucursal && !cargandoEmpresas" class="row">
        <div class="col-12 text-secondary">
          EMPRESA
        </div>
        <div class="col-12">
          <ion-item>
            <ion-select ok-text="ACEPTAR" cancel-text="CANCELAR" interface="action-sheet" placeholder="SELECCIONE.." @ionChange="filtros.sucursal=''; listarSucursales(); filtros.tipo=''; listarTipos();" v-model="filtros.empresa">
              <ion-select-option :key ="index+'emp'" v-for="(empresa, index) in empresas" :value="empresa.emp_id" v-text="empresa.emp_nombre"></ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </div>

      <div v-if="filtros.filtroSucursal && !cargandoSucursales" class="row mt-3">
        <div class="col-12 text-secondary">
          SUCURSAL
        </div>
        <div class="col-12">
          <ion-item>
            <ion-select :disabled="filtros.empresa == ''" ok-text="ACEPTAR" cancel-text="CANCELAR" interface="action-sheet" placeholder="SELECCIONE.." v-model="filtros.sucursal">
              <ion-select-option :key ="index+'suc'" v-for="(sucursal, index) in sucursales" :value="sucursal.suc_id" v-text="sucursal.suc_nombre"></ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </div>

      <div v-if="filtros.filtroFecha && !cargandoAnos" class="row mt-3">
        <div class="col-12 text-secondary">
          AÑO
        </div>
        <div class="col-12">
          <ion-item>
            <ion-select ok-text="ACEPTAR" cancel-text="CANCELAR" interface="action-sheet" placeholder="SELECCIONE.." v-model="filtros.ano">
              <ion-select-option :key ="index+'ano'" v-for="(ano, index) in anos" :value="ano.value" v-text="ano.text"></ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </div>

      <div v-if="filtros.filtroFecha && !cargandoAnos" class="row mt-3">
        <div class="col-12 text-secondary">
          MES
        </div>
        <div class="col-12">
          <ion-item>
            <ion-select :disabled="filtros.ano == ''" ok-text="ACEPTAR" cancel-text="CANCELAR" interface="action-sheet" placeholder="SELECCIONE.." v-model="filtros.mes">
              <ion-select-option :key ="index+'mes'" v-for="(mes, index) in meses" :value="mes.value" v-text="mes.text"></ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </div>

      <div v-if="filtros.empresa != '' && filtros.filtroTipo" class="row mt-3">
        <div class="col-12 text-secondary">
          TIPOS
        </div>
        <div class="col-12">
          <ion-item>
            <ion-select :disabled="filtros.empresa == ''" ok-text="ACEPTAR" cancel-text="CANCELAR" interface="action-sheet" placeholder="SELECCIONE.." v-model="tipo" @ionChange="listarSubTipos(tipo, 1); subTipo1='';">
              <ion-select-option :key ="index+'tp1'" v-for="(tev, index) in tipos" :value="tev.tev_id" v-text="tev.tev_tipo"></ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </div>

      <div v-if="subTipos1.length > 0" class="row mt-3">
        <div class="col-12 text-secondary">
          SUBATEGORÍA 1
        </div>
        <div class="col-12">
          <ion-item>
            <ion-select interface="action-sheet" cancel-text="CANCELAR" ok-text="ACEPTAR" placeholder="SELECCIONE.." @ionChange="listarSubTipos(subTipo1, 2);" v-model="subTipo1">
              <ion-select-option :key ="index+'tp2'" v-for="(tev, index) in subTipos1" :value="tev.tev_id" v-text="tev.tev_tipo"></ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </div>

      <div v-if="subTipos2.length > 0" class="row mt-3">
        <div class="col-12 text-secondary">
          SUBCATEGORÍA 2
        </div>
        <div class="col-12">
          <ion-item>
            <ion-select interface="action-sheet" cancel-text="CANCELAR" ok-text="ACEPTAR" placeholder="SELECCIONE.." @ionChange="filtros.tipo=subTipo2" v-model="subTipo2">
              <ion-select-option :key ="index+'tp3'" v-for="(tev, index) in subTipos2" :value="tev.tev_id" v-text="tev.tev_tipo"></ion-select-option>
            </ion-select>
          </ion-item>
        </div>
      </div>

    </div>

  </ion-content>

  <ion-footer>
    <div class="row mx-2 mb-1 mt-1">
      <div class="col-6">
        <ion-button color="danger" @click="cerrarModal()" expand="block" shape="round">CERRAR</ion-button>
      </div>
      <div class="col-6">
        <ion-button :disabled="!validaDatos()" @click="aplicarFiltros();" color="success" expand="block" shape="round">FILTRAR</ion-button>
      </div>
    </div>
  </ion-footer>
</template>

<script>
import { modalController, toastController, IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonSelect, IonSelectOption, IonItem, loadingController, IonToggle} from '@ionic/vue';
import { defineComponent      } from 'vue';
import { addIcons             } from 'ionicons';
import { arrowBackOutline, trashOutline, settingsOutline} from 'ionicons/icons';
import { Preferences          } from '@capacitor/preferences';
import { cerrarSesion         } from '@/plugins/funciones.ts';
import * as $                   from "jquery";
import axios                    from 'axios';
import rutaBase                 from '@/plugins/variables';

export default defineComponent({
  name: 'ModalFiltrosHistorial',
  props: {
    propFiltros  : Object,
    modal       : Object
  },
  components: { IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonSelect, IonSelectOption, IonItem, IonToggle},
  data(){
    return {
      cargandoEmpresas    : false,
      cargandoSucursales  : false,
      cargandoAnos        : false,
      cargandoTipos       : false,
      empresas            : [],
      sucursales          : [],
      tipos               : [],
      subTipos1           : [],
      subTipos2           : [],
      tipo                : '',
      subTipo1            : '',
      subTipo2            : '',

      filtros             : {filtroSucursal:false, empresa:'', sucursal:'', filtroFecha:false, ano:'', mes:'', filtroTipo:false, tipo:''},
      anos                : [],
      meses               : [
        {value:1, text:'Enero'},
        {value:2, text:'Febrero'},
        {value:3, text:'Marzo'},
        {value:4, text:'Abril'},
        {value:5, text:'Mayo'},
        {value:6, text:'Junio'},
        {value:7, text:'Julio'},
        {value:8, text:'Agosto'},
        {value:9, text:'Septiembre'},
        {value:10, text:'Octubre'},
        {value:11, text:'Noviembre'},
        {value:12, text:'Diciembre'},
      ]
    }
  },
  created() {
    addIcons({
      'arrow-back-outline'  : arrowBackOutline,
      'trash-outline'       : trashOutline,
      'settings-outline'    : settingsOutline
    });
  },
  mounted(){
    this.datosUsuario();
    this.listarEmpresas();
    this.filtros = JSON.parse(JSON.stringify(this.propFiltros));
    if(this.filtros.empresa != ''){
      this.listarSucursales();
      this.listarTipos();
    }
    if(this.filtros.filtroFecha){
      this.listarAnosEventos();
    }
    this.filtros.tipo = '';
  },
  methods:{
    async datosUsuario(){
      this.rutUsuario  = (await Preferences.get({ key: 'rut' })).value;
      this.tipoUsuario = (await Preferences.get({ key: 'tipo_usuario' })).value;
    },

    async listarEmpresas(){
      this.cargandoEmpresas = true;
      const modalCarga      = await this.modalCargando();
      const token           = await Preferences.get({ key: 'token_auth' });
      const headers         = { headers: { 'Authorization': `${token.value}` } };

      axios.post(rutaBase+'/soporte/listarEmpresas', null, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          this.empresas = resp.data;
          modalCarga.dismiss();
          this.cargandoEmpresas = false;
        }
      }).catch(() =>{
        console.log("ERROR AL LISTAR EMPRESAS");
        modalCarga.dismiss();
        this.cargandoEmpresas = false;
      });
    },

    async listarSucursales(){
      this.cargandoSucursales = true;
      const modalCarga        = await this.modalCargando();
      const token             = await Preferences.get({ key: 'token_auth' });
      const headers           = { headers: { 'Authorization': `${token.value}` } };
      const data              = new URLSearchParams();
      data.append('id_empresa', this.filtros.empresa);
      axios.post(rutaBase+'/soporte/listarSucursalesEmpresa', data, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          if(resp.data.length == 1){
            this.filtros.sucursal = resp.data[0].suc_id;
          }
          this.sucursales = resp.data;
          modalCarga.dismiss();
          this.cargandoSucursales = false;
        }
      }).catch(() =>{
        console.log("ERROR AL LISTAR SUCURSALES");
        modalCarga.dismiss();
        this.cargandoSucursales = false;
      });
    },

    async listarAnosEventos(){
      this.cargandoAnos = true;
      const modalCarga        = await this.modalCargando();
      const token             = await Preferences.get({ key: 'token_auth' });
      const headers           = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/soporte/listarAnosEventos', null, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          this.anos = resp.data;
          modalCarga.dismiss();
          this.cargandoAnos = false;
        }
      }).catch(() =>{
        console.log("ERROR AL LISTAR AÑOS");
        modalCarga.dismiss();
        this.cargandoAnos = false;
      });
    },

    async listarTipos(){
      this.cargandoTipos = true;
      const modalCarga        = await this.modalCargando();
      const token             = await Preferences.get({ key: 'token_auth' });
      const headers           = { headers: { 'Authorization': `${token.value}` } };
      const data              = new URLSearchParams();
      data.append('id_empresa', this.filtros.empresa);
      axios.post(rutaBase+'/soporte/listarTiposEventoEmpresa', data, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          this.tipos = resp.data;
          modalCarga.dismiss();
          this.cargandoTipos = false;
        }
      }).catch(() =>{
        console.log("ERROR AL LISTAR TIPOS");
        modalCarga.dismiss();
        this.cargandoTipos = false;
      });
    },

    async listarSubTipos(idTipo, tipoHijo){
      this.cargandoTipos = true;
      const modalCarga        = await this.modalCargando();
      const token             = await Preferences.get({ key: 'token_auth' });
      const headers           = { headers: { 'Authorization': `${token.value}` } };
      const data              = new URLSearchParams();
      data.append('id_tipo', idTipo);
      axios.post(rutaBase+'/soporte/listarSubTiposEvento', data, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          if(tipoHijo == 1) {
            this.subTipos1 = resp.data; 
            this.subTipos2 = []; 
          }
          if(tipoHijo == 2) {
            this.subTipos2 = resp.data;
          }
          if(resp.data.length == 0) {
            this.filtros.tipo = idTipo;
          }
          modalCarga.dismiss();
          this.cargandoTipos = false;
        }
      }).catch(() =>{
        console.log("ERROR AL LISTAR TIPOS");
        modalCarga.dismiss();
        this.cargandoTipos = false;
      });
    },

    async aplicarFiltros(){
      const datos = {recargar:true, filtros:this.filtros};
      this.cerrarModal(datos);
    },

    validaDatos(){
      if(
        (this.filtros.filtroSucursal  && (this.filtros.empresa == ''  || this.filtros.sucursal == ''))  || 
        (this.filtros.filtroFecha     && (this.filtros.ano == ''      || this.filtros.mes == ''))       ||
        (this.filtros.filtroTipo      && (this.filtros.tipo == ''))
      ){
        return false;
      }
      else{
        return true;
      }
    },

    async modalCargando(){
      const modal = await loadingController
        .create({
          cssClass  : 'text-secondary',
          message   : 'CARGANDO...',
          animated  : true,
          mode      : 'md'
        });
      await modal.present();
      return modal;
    },

    async cerrarModal(dato={recargar:false}){
      modalController.dismiss(dato);
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    },


  }
});
</script>

<style>
.textarea-wrapper{
  border:1px solid #c3c3c3 !important;
  border-radius: 3px !important;
}

.searchbar-input-container input {
  border-radius: 50rem!important;
  background-color: lightgrey!important;
  color: black!important;
}

</style>